import { Schedule } from '@app/models/payroll/schedule.model';
import moment from 'moment';

export const getInitialDatesForYTD = (): [Date, Date] => {
    return [moment().startOf('year').toDate(), moment().startOf('day').toDate()];
};

export const getInitialDatesForEntireYear = (): [Date, Date] => {
    return [moment().startOf('year').toDate(), moment().endOf('year').toDate()];
};

export const getInitialDatesByLastPaidCheque = (schedule?: Schedule): [Date, Date] => {
    const lastPaidPeriod = schedule?.lastPaidPeriod;

    if (lastPaidPeriod) {
        return [moment(lastPaidPeriod.chequeDate).toDate(), moment(lastPaidPeriod.chequeDate).add(1, 'day').toDate()];
    }

    return getInitialDatesForYTD();
};
